import { render } from "./DatasetUploaderTemplateModal.vue?vue&type=template&id=766d96fd"
import script from "./DatasetUploaderTemplateModal.vue?vue&type=script&lang=js"
export * from "./DatasetUploaderTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__